const getDigits = (str) => String(str || '').replace(/\D/g, '');

// Позиция в отформатированной строке сразу после n-й цифры
const caretAfterDigits = (str, digitsCount) => {
  if (!digitsCount) return 0;

  let seen = 0;
  for (let i = 0; i < str.length; i += 1) {
    if (/\d/.test(str[i])) seen += 1;
    if (seen === digitsCount) return i + 1;
  }

  return str.length;
};

// 000-000-000 00
export const formatSnils = (value) => {
  const digits = getDigits(value).slice(0, 11);
  const groups = [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 9)]
    .filter(Boolean)
    .join('-');

  return digits.length > 9 ? `${groups} ${digits.slice(9)}` : groups;
};

// 8 (000) 000-0000 — формат прежней маски type '1'
// Номер не с 7/8 получает 8 впереди — и при посимвольном вводе, и при вставке
export const formatPhone = (value) => {
  let digits = getDigits(value);
  if (digits && !/^[78]/.test(digits)) digits = `8${digits}`;

  const x = digits.match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/);

  return !x[3] ? x[1] + x[2] : `${x[1]} (${x[2]}) ${x[3]}${x[4] ? `-${x[4]}` : ''}`;
};

// ДД.ММ.ГГГГ
export const formatDate = (value) => {
  const digits = getDigits(value).slice(0, 8);
  return [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4)]
    .filter(Boolean)
    .join('.');
};

const maskHandlers = new WeakMap();

const getInput = (el) => (el.tagName === 'INPUT' ? el : el.querySelector('input'));

// Форматирует ввод, сохраняет позицию курсора и сообщает новое значение v-model
// через синтетический input (его сами же пропускаем по isTrusted)
const attachMask = (el, format) => {
  if (maskHandlers.has(el)) return;

  const input = getInput(el);
  if (!input) return;

  const handler = (e) => {
    if (!e.isTrusted) return;

    const { value } = input;
    const formatted = format(value);
    if (formatted === value) return;

    const caret = input.selectionStart == null ? value.length : input.selectionStart;
    const digitsBeforeCaret = getDigits(value.slice(0, caret)).length;

    input.value = formatted;

    if (document.activeElement === input) {
      const pos = caretAfterDigits(formatted, digitsBeforeCaret);
      input.setSelectionRange(pos, pos);
    }

    input.dispatchEvent(new Event('input', { bubbles: true }));
  };

  input.addEventListener('input', handler);
  maskHandlers.set(el, { input, handler });
};

const detachMask = (el) => {
  const entry = maskHandlers.get(el);
  if (!entry) return;

  entry.input.removeEventListener('input', entry.handler);
  maskHandlers.delete(el);
};

// function dMask(el) {
//   const input = el.querySelector('input') ? el.querySelector('input') : el;

//   const maskStr = '__.__.____';

//   function setInitialMask() {
//     input.value = maskStr;
//     input.setSelectionRange(0, 0);
//   }
//   input.onfocus = (e) => {
//     if (input.value === '' || input.value === maskStr) {
//       e.preventDefault();
//       setInitialMask();
//     } else if (input.value && input.value !== maskStr) {
//       // input.setSelectionRange(0, 10);
//     }
//   };
//   input.onmouseup = (e) => {
//     if (input.value === '' || input.value === maskStr) {
//       e.preventDefault();
//       setInitialMask();
//     } else if (input.value && input.value !== maskStr) {
//       input.setSelectionRange(0, 10);
//     }
//   };

//   function implementMask(str) {
//     const digitsArr = extractDigits(str);
//     const maskArr = maskStr.split('');
//     const setDate = () => {
//       maskArr.splice(0, digitsArr.length, ...digitsArr);
//       input.setSelectionRange(digitsArr.length, digitsArr.length);
//       return maskArr.join('');
//     };
//     const setMonth = () => {
//       maskArr.splice(0, 2, digitsArr[0], digitsArr[1]);
//       maskArr.splice(3, (digitsArr.length - 2), ...digitsArr.slice(2));
//       input.setSelectionRange(digitsArr.length + 1, digitsArr.length + 1);
//       return maskArr.join('');
//     };
//     const setYear = () => {
//       maskArr.splice(0, 2, digitsArr[0], digitsArr[1]);
//       maskArr.splice(3, 2, digitsArr[2], digitsArr[3]);
//       maskArr.splice(6, digitsArr.length - 4, ...digitsArr.slice(4));
//       input.setSelectionRange(digitsArr.length + 2, digitsArr.length + 2);
//       return maskArr.join('');
//     };
//     if (digitsArr.length < 3) {
//       return setDate();
//     }
//     if (digitsArr.length < 5) {
//       return setMonth();
//     }
//     if (digitsArr.length < 9) {
//       return setYear();
//     }
//     if (digitsArr.length >= 9) {
//       digitsArr.splice(8);
//       return setYear();
//     }
//   }

//   input.addEventListener('input', (e) => {
//     const newVal = implementMask(input.value);
//     console.log(newVal);
//     if (newVal) {
//       input.value = newVal;
//       console.log(input.value);
//     } else {
//       e.preventDefault();
//       return false;
//     }
//     // если убрать второй вызов implementMask, ломается setSelectionRange, хз почему
//     implementMask(input.value);
//   });

//   input.addEventListener('paste', (e) => {
//     e.preventDefault();
//     const str = e.clipboardData.getData('text');
//     const newVal = implementMask(str);
//     if (newVal) {
//       input.value = newVal;
//     } else {
//       e.preventDefault();
//       return false;
//     }
//   });

//   el.oninput = function (e) {
//     if (!e.isTrusted) {
//       return false;
//     }
//   };
// }

const tooltip = (el, args) => {
  const div = document.createElement('div');
  el.addEventListener('mouseover', (ev) => {
    const app = document.querySelector('#app');
    div.classList.add('tooltip');
    div.innerText = args.content;
    div.style.top = `${ev.clientY}px`;
    div.style.left = `${ev.clientX}px`;
    app.append(div);
    const width = div.offsetWidth;
    if (args.pos === 'left') {
      div.style.left = `${ev.clientX - width}px`;
    }
  });
  el.addEventListener('mouseout', () => {
    div.remove();
  });
};

// input может появиться внутри компонента не сразу, поэтому attach и в updated (он идемпотентен)
const createMaskDirective = (getFormat) => ({
  mounted(el, binding) {
    const format = getFormat(binding);
    if (format) attachMask(el, format);
  },
  updated(el, binding) {
    const format = getFormat(binding);
    if (format) attachMask(el, format);
  },
  unmounted(el) {
    detachMask(el);
  },
});

// Как и раньше: форматирование только для v-phone:1
export const phoneMask = createMaskDirective(
  (binding) => (binding.arg === '1' ? formatPhone : null),
);

// Как и раньше: маска включается значением v-date-mask="true"
export const dateMask = createMaskDirective((binding) => (binding.value ? formatDate : null));

export const snilsMask = createMaskDirective(() => formatSnils);

export const showTooltip = {
  mounted(el, binding) {
    tooltip(el, binding.value);
  },
};
